import type { FindFn } from "@shared/models/analytics/base"
import { createBlankEvent } from "@shared/models/analytics/base"
import type { CourseAnalyze } from "@shared/models/analytics/course"
import { getPossessiveForPlanbook } from "@shared/models/analytics/planbook"
import type { Planbook } from "@shared/models/planbook"
import type { PreparedAction } from "../../action-doc-builder"
import { partial } from "lodash-es"
import type { Narrative } from "../create-narrative"
import defaultCourseContext from "./default-course-context"
import defaultCourseModels from "./default-course-models"

interface Payload {
  courseId: string
  planbook: Planbook
  selectedStandardSetSubject: string
  selectedStandardSetTitle: string
}

export default function courseAnalyzeStandardsTrackerAction(payload: Payload): PreparedAction {
  return {
    name: "COURSE_ANALYZE_STANDARDS_TRACKER",
    payload: payload,
    patches: null,
    undoPatches: null,
    narrative: partial(narrative, payload),
  }
}

function narrative(payload: Payload, findFn: FindFn, userId: string): Narrative {
  let models = defaultCourseModels(payload, findFn, userId)

  let newEvent: CourseAnalyze = {
    ...createBlankEvent(),
    root_id: payload.planbook.id,
    root_type: "planbook",
    date_plan_scheduled_for: null,

    primary_verb: "analyze",
    primary_possessive: getPossessiveForPlanbook(findFn, userId, payload.planbook.id),

    primary_object_type: "course",
    primary_object_id: payload.courseId,
    primary_object_specifier: "standards_tracker",
    primary_object_id_and_ancestor_ids: [payload.planbook.id, payload.courseId],

    adverbial_verb: null,

    adverbial_object_type: null,
    adverbial_object_id: null,
    adverbial_object_specifier: null,
    adverbial_object_id_and_ancestor_ids: [payload.planbook.id, payload.courseId],
  }

  return {
    title: "Analyzed a Course",
    titleForAnalytics: "Course - Analyze Standards Tracker",
    description: `User analyzed ${payload.selectedStandardSetSubject} - ${payload.selectedStandardSetTitle} standard set used in the ${models.course?.attributes.title} course with the Standards Tracker`,
    context: defaultCourseContext(payload, models),
    activity: {},
    newAnalyticsEvents: [newEvent],
  }
}
